<template>
  <div class="menu dinline-block vtop fs14 pl35">
    <div class="tleft pl5 pr10 tc6 pb15">
      <div class="fs24 mr5 dinline-block prelative">
        <span class="img-schange img-bg dinline-block vbottom"></span>
        {{categoryName}}
      </div>
      <div class="pt10 fr">
        当前位置:
        <span>实习就业 > </span>
        <span>{{categoryName}}</span>
      </div>
    </div>
    <div class="notices border-red tleft pt15 pl15 pr10 pb20">
      <template v-if="list">
        <practice-article-row v-for="item in list" :key="item.id" :item="item" @click="goDetail(item.id)" />
      </template>
    </div>
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="$route.query.category_id"/>
  </div>
</template>

<script>
import Pagec from "../../components/un_index/Page";
import PracticeArticleRow from '@/components/practice/ArticleRow'

export default {
  name: "practiceList",
  data(){
    return {
      id:'',
      pid:'',
      perPage:20,
      page:1,
      list:[],
      msg:'加载中……',
      total:0,
      categoryName: ''
    }
  },
  components:{
    Pagec,
    PracticeArticleRow
  },
  updated() {
  },
  created() {
    this.id = this.$route.query.id
    this.pid = this.$route.query.pid
    this.setCategoryName()
    this.getData(1)
  },
  methods:{
    setCategoryName(){
      const categoryNames = {
        '1': '通知公告',
        '2': '新闻速递',
        '3': '实习岗位',
        '4': '招聘公告',
        '5': '招聘会',
        '6': '全职岗位'
      }
      this.categoryName = categoryNames[this.id] || '实习就业'
    },
    goDetail(article_id){
      var query = this.$route.query;
      query.article_id = article_id;
      this.$router.push({path:'/practice/article/detail',query:query});
    },
    clearList(){
    },
    getData(page){
      this.page = page;
      var getParam = {}
      var id = this.$route.query['id']
      getParam['category_id'] = id
      getParam['perPage'] = this.perPage
      getParam['page'] = this.page
      this.$request.get('practice-article/list',getParam,response => {
        if(response.status == 200 && response.data.data.data.length > 0){
          let res = response.data.data.data
          this.list = res
          this.total = response.data.data.total
        }else{
          this.msg = '无数据';
        }
      },error => {
        console.log(error)
      })
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        this.list = []
        this.page = 1
        this.setCategoryName()
        this.getData(1)
      }
    },
  },
}
</script>

<style scoped>
  .menu{width: 930px;margin-top:0;}
  .img-media{background: url(../../assets/images/scn1.png) no-repeat -60px -28px;}
  .img-sinfo{background: url(../../assets/images/scn1.png) no-repeat -60px -195px;}
  .img-schange{background: url(../../assets/images/scn1.png) no-repeat -60px -280px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-sproblem{background: url(../../assets/images/scn1.png) no-repeat -60px -448px;}
  .img-sdown{background: url(../../assets/images/scn1.png) no-repeat -60px -528px;}
</style>



// WEBPACK FOOTER //
// src/pages/practice/list.vue